import AuthLayout from '@/layouts/Auth'
import MainLayout from '@/layouts/Main'
import Router from 'vue-router'
import Vue from 'vue'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: false,
      },
      children: [
        // DASHBOARDS -------------------------------------
        {
          path: '/dashboard',
          meta: {
            title: 'Dashboard',
          },
          component: () => import('./views/dashboard/alpha'),
        },
        // CRM MODULE-------------------------------------
        // - customers
        {
          name: 'crm-customers',
          path: '/crm/customers',
          meta: {
            title: 'Customers',
          },
          component: () => import('./views/crm/customers'),
        },
        // - quick-search
        {
          name: 'crm-quick-search',
          path: '/crm/quick-search',
          meta: {
            title: 'Quick Search',
          },
          component: () => import('./views/crm/quick-search'),
        },
        // - customer
        {
          name: 'customer-detail',
          path: '/crm/customer/:id',
          meta: {
            title: 'Customer',
          },
          component: () => import('./views/crm/customer'),
        },

        // PM MODULE-------------------------------------
        // - projects
        {
          name: 'projects',
          path: '/pm/projects',
          meta: {
            title: 'Projects',
          },
          component: () => import('./views/pm/projects'),
        },
        {
          name: 'project-detail',
          path: '/pm/project/:id',
          meta: {
            title: 'Project',
          },
          component: () => import('./views/pm/project'),
        },
        {
          name: 'contracts',
          path: '/pm/contracts',
          meta: {
            title: 'Contracts',
          },
          component: () => import('./views/pm/contracts'),
        },
        {
          name: 'contract-detail',
          path: '/pm/contract',
          meta: {
            title: 'Contract',
          },
          component: () => import('./views/pm/contract'),
        },
        {
          name: 'tasks',
          path: '/pm/tasks',
          meta: {
            title: 'Tasks',
          },
          component: () => import('./views/pm/tasks'),
        },
        {
          name: 'task-detail',
          path: '/pm/task',
          meta: {
            title: 'Task',
          },
          component: () => import('./views/pm/task'),
        },
        {
          name: 'teams',
          path: '/pm/teams',
          meta: {
            title: 'Tasks',
          },
          component: () => import('./views/pm/teams'),
        },
        {
          name: 'team-detail',
          path: '/pm/team',
          meta: {
            title: 'Task',
          },
          component: () => import('./views/pm/team'),
        },

        // MARKETING MODULE-------------------------------------
        // - Campaigns
        {
          name: 'campaigns',
          path: '/marketing/campaigns',
          meta: {
            title: 'Campaigns List',
          },
          component: () => import('./views/marketing/campaigns'),
        },
        // - Campaign Creation
        {
          name: 'campaign-create',
          path: '/marketing/campaign/create',
          meta: {
            title: 'Campaign Detail',
          },
          component: () => import('./views/marketing/campaign/create'),
        },
        // - Campaign Detail
        {
          name: 'campaign-detail',
          path: '/marketing/campaign/:id',
          meta: {
            title: 'Campaign Detail',
          },
          component: () => import('./views/marketing/campaign'),
        },
        // - Recipients
        {
          name: 'recipients',
          path: '/marketing/recipients',
          meta: {
            title: 'Recipients',
          },
          component: () => import('./views/marketing/recipients'),
        },
        {
          name: 'recipients-create',
          path: '/marketing/recipients/create',
          meta: {
            title: 'Create Recipient Group',
          },
          component: () => import('./views/marketing/recipients/create'),
        },
        // - Recipient Detail
        {
          name: 'recipients-detail',
          path: '/marketing/recipient',
          meta: {
            title: 'Recipient Detail',
          },
          component: () => import('./views/marketing/recipient'),
        },
        {
          name: 'recipients-edit',
          path: '/marketing/recipients/edit/:id',
          meta: {
            title: 'Edit Recipient Group',
          },
          component: () => import('./views/marketing/recipients/edit'),
        },
        // - Notification
        {
          name: 'notification',
          path: '/marketing/notification',
          meta: {
            title: 'Notification',
          },
          component: () => import('./views/marketing/notification'),
        },

        // SYSTEM MODULE-------------------------------------
        // - Setting
        {
          name: 'system-setting',
          path: '/system/settings',
          meta: {
            title: 'System Settings',
          },
          component: () => import('./views/system/settings'),
        },
        // - Staffs
        {
          name: 'staffs',
          path: '/system/staffs',
          meta: {
            title: 'Staffs',
          },
          component: () => import('./views/system/staffs'),
        },
        // - Staff
        {
          name: 'staff-detail',
          path: '/system/staff/:id',
          meta: {
            title: 'Staff Details',
          },
          component: () => import('./views/system/staff'),
        },
        // ADMIN MODULE-------------------------------------
        // - Contractors
        {
          name: 'admin-contractors',
          path: '/admin/contractors',
          meta: {
            title: 'Contractors',
          },
          component: () => import('./views/admin/contractors'),
        },
        {
          name: 'admin-contractor',
          path: '/admin/contractor/:id',
          meta: {
            title: 'Contractor Details',
          },
          component: () => import('./views/admin/contractor'),
        },
        // - Users
        {
          name: 'admin-users',
          path: '/admin/users',
          meta: {
            title: 'Users',
          },
          component: () => import('./views/admin/users'),
        },
        // - User
        {
          name: 'admin-user',
          path: '/admin/user/:id',
          meta: {
            title: 'Users Detail',
          },
          component: () => import('./views/admin/user'),
        },

        // Ecommerce
        {
          path: '/ecommerce/dashboard',
          meta: {
            title: 'Ecommerce Dashboard',
          },
          component: () => import('./views/ecommerce/dashboard'),
        },
        {
          path: '/ecommerce/orders',
          meta: {
            title: 'Ecommerce Orders',
          },
          component: () => import('./views/ecommerce/orders'),
        },
        {
          path: '/ecommerce/product-catalog',
          meta: {
            title: 'Ecommerce Product Catalog',
          },
          component: () => import('./views/ecommerce/product-catalog'),
        },
        {
          path: '/ecommerce/product-details',
          meta: {
            title: 'Ecommerce Product Details',
          },
          component: () => import('./views/ecommerce/product-details'),
        },
        {
          path: '/ecommerce/cart',
          meta: {
            title: 'Ecommerce Cart',
          },
          component: () => import('./views/ecommerce/cart'),
        },
        // Widgets
        {
          path: '/widgets/general',
          meta: {
            title: 'Widgets / General',
          },
          component: () => import('./views/widgets/general'),
        },
        {
          path: '/widgets/lists',
          meta: {
            title: 'Widgets / Lists',
          },
          component: () => import('./views/widgets/lists'),
        },
        {
          path: '/widgets/tables',
          meta: {
            title: 'Widgets / Tables',
          },
          component: () => import('./views/widgets/tables'),
        },
        {
          path: '/widgets/charts',
          meta: {
            title: 'Widgets / Charts',
          },
          component: () => import('./views/widgets/charts'),
        },
        // Apps
        {
          path: '/apps/calendar',
          meta: {
            title: 'Apps / Calendar',
          },
          component: () => import('./views/apps/calendar'),
        },
        {
          path: '/apps/digitalocean-create',
          meta: {
            title: 'Apps / DigitalOcean Create',
          },
          component: () => import('./views/apps/digitalocean-create'),
        },
        {
          path: '/apps/digitalocean-droplets',
          meta: {
            title: 'Apps / DigitalOcean Droplets',
          },
          component: () => import('./views/apps/digitalocean-droplets'),
        },
        {
          path: '/apps/gallery',
          meta: {
            title: 'Apps / Gallery',
          },
          component: () => import('./views/apps/gallery'),
        },
        {
          path: '/apps/github-discuss',
          meta: {
            title: 'Apps / GitHub Discuss',
          },
          component: () => import('./views/apps/github-discuss'),
        },
        {
          path: '/apps/github-explore',
          meta: {
            title: 'Apps / GitHub Explore',
          },
          component: () => import('./views/apps/github-explore'),
        },
        {
          path: '/apps/google-analytics',
          meta: {
            title: 'Apps / Google Analytics',
          },
          component: () => import('./views/apps/google-analytics'),
        },
        {
          path: '/apps/helpdesk-dashboard',
          meta: {
            title: 'Apps / Helpdesk Dashboard',
          },
          component: () => import('./views/apps/helpdesk-dashboard'),
        },
        {
          path: '/apps/jira-agile-board',
          meta: {
            title: 'Apps / Jira Agile Board',
          },
          component: () => import('./views/apps/jira-agile-board'),
        },
        {
          path: '/apps/jira-dashboard',
          meta: {
            title: 'Apps / Jira Dashboard',
          },
          component: () => import('./views/apps/jira-dashboard'),
        },
        {
          path: '/apps/mail',
          meta: {
            title: 'Apps / Mail',
          },
          component: () => import('./views/apps/mail'),
        },
        {
          path: '/apps/messaging',
          meta: {
            title: 'Apps / Mesagging',
          },
          component: () => import('./views/apps/messaging'),
        },
        {
          path: '/apps/profile',
          meta: {
            title: 'Apps / Profile',
          },
          component: () => import('./views/apps/profile'),
        },
        {
          path: '/apps/todoist-list',
          meta: {
            title: 'Apps / Todoist List',
          },
          component: () => import('./views/apps/todoist-list'),
        },
        {
          path: '/apps/wordpress-add',
          meta: {
            title: 'Apps / Wordpress Add',
          },
          component: () => import('./views/apps/wordpress-add'),
        },
        {
          path: '/apps/wordpress-post',
          meta: {
            title: 'Apps / Wordpress Post',
          },
          component: () => import('./views/apps/wordpress-post'),
        },
        {
          path: '/apps/wordpress-posts',
          meta: {
            title: 'Apps / Wordpress Posts',
          },
          component: () => import('./views/apps/wordpress-posts'),
        },
        // Cards
        {
          path: '/cards/basic-cards',
          meta: {
            title: 'Cards / Basic',
          },
          component: () => import('./views/cards/basic-cards'),
        },
        {
          path: '/cards/tabbed-cards',
          meta: {
            title: 'Cards / Tabbed',
          },
          component: () => import('./views/cards/tabbed-cards'),
        },
        // UI Kits
        {
          path: '/ui-kits/bootstrap',
          meta: {
            title: 'UI Kit / Bootstrap',
          },
          component: () => import('./views/ui-kits/bootstrap'),
        },
        {
          path: '/ui-kits/antd',
          meta: {
            title: 'UI Kit / Ant Design',
          },
          component: () => import('./views/ui-kits/antd'),
        },
        // Tables
        {
          path: '/tables/bootstrap',
          meta: {
            title: 'Tables / Bootstrap',
          },
          component: () => import('./views/tables/bootstrap'),
        },
        {
          path: '/tables/antd',
          meta: {
            title: 'Tables / Ant Design',
          },
          component: () => import('./views/tables/antd'),
        },
        // Charts
        {
          path: '/charts/chartistjs',
          meta: {
            title: 'Charts / Chartist.js',
          },
          component: () => import('./views/charts/chartistjs'),
        },
        {
          path: '/charts/chartjs',
          meta: {
            title: 'Charts / Chart.js',
          },
          component: () => import('./views/charts/chartjs'),
        },
        {
          path: '/charts/c3',
          meta: {
            title: 'Charts / C3 Charts',
          },
          component: () => import('./views/charts/c3'),
        },
        // Icons
        {
          path: '/icons/feather-icons',
          meta: {
            title: 'Icons / Feather',
          },
          component: () => import('./views/icons/feather-icons'),
        },
        {
          path: '/icons/fontawesome',
          meta: {
            title: 'Icons / Fontawesome',
          },
          component: () => import('./views/icons/fontawesome'),
        },
        {
          path: '/icons/linearicons-free',
          meta: {
            title: 'Icons / Linearicons Free',
          },
          component: () => import('./views/icons/linearicons-free'),
        },
        {
          path: '/icons/icomoon-free',
          meta: {
            title: 'Icons / Icomoon Free',
          },
          component: () => import('./views/icons/icomoon-free'),
        },
        // Advanced
        {
          path: '/advanced/form-examples',
          meta: {
            title: 'Advanced / Form Examples',
          },
          component: () => import('./views/advanced/form-examples'),
        },
        {
          path: '/advanced/email-templates',
          meta: {
            title: 'Advanced / Email Templates',
          },
          component: () => import('./views/advanced/email-templates'),
        },
        {
          path: '/advanced/utilities',
          meta: {
            title: 'Advanced / Utilities',
          },
          component: () => import('./views/advanced/utilities'),
        },
        {
          path: '/advanced/grid',
          meta: {
            title: 'Advanced / Grid',
          },
          component: () => import('./views/advanced/grid'),
        },
        {
          path: '/advanced/typography',
          meta: {
            title: 'Advanced / Typography',
          },
          component: () => import('./views/advanced/typography'),
        },
        {
          path: '/advanced/pricing-tables',
          meta: {
            title: 'Advanced / Pricing Tables',
          },
          component: () => import('./views/advanced/pricing-tables'),
        },
        {
          path: '/advanced/invoice',
          meta: {
            title: 'Advanced / Invoice',
          },
          component: () => import('./views/advanced/invoice'),
        },
        {
          path: '/advanced/colors',
          meta: {
            title: 'Advanced / Colors',
          },
          component: () => import('./views/advanced/colors'),
        },
      ],
    },
    // System Pages
    {
      path: '/auth',
      component: AuthLayout,
      redirect: 'auth/login',
      children: [
        {
          path: '/auth/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/auth/404'),
        },
        {
          path: '/auth/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/auth/500'),
        },
        {
          path: '/auth/login',
          meta: {
            title: 'Sign In',
          },
          component: () => import('./views/auth/login'),
        },
        {
          path: '/auth/register',
          meta: {
            title: 'Sign Up',
          },
          component: () => import('./views/auth/register'),
        },
        {
          path: '/auth/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/auth/forgot-password'),
        },
        {
          path: '/auth/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/auth/lockscreen'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*',
      redirect: 'auth/404',
      hidden: true,
    },
  ],
})

// router guarding:
router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.authRequired)) {
    if (await store.dispatch('user/AUTH', null)) {
      next()
    } else {
      next({ path: '/auth/login', query: { redirect: to.fullPath } })
    }
  } else {
    next()
  }
})

export default router
